// Mapa centralizado: stageId → asset de background do card no Mapa de Fases.
// Única fonte de verdade entre stages.json e a tela de menu.
// Para adicionar uma fase nova: registre o id aqui apontando para um PNG em
// /client/public/assets/backgrounds/. Sem entrada, cai no FALLBACK.

const ASSET_BASE = '/assets/backgrounds/thumbs/'
const FALLBACK_FILE = 'bg_quintal.png'

const STAGE_BACKGROUND: Record<string, string> = {
  // Capítulo 1
  stage_01_quintal: 'bg_quintal.png',
  stage_02_beco: 'bg_beco.png',
  stage_03_mercado: 'bg_mercado_modelo.png',
  stage_04_lapa: 'bg_lapa.png',
  stage_05_pelourinho: 'bg_pelourinho.png',
  stage_06_quilombo: 'bg_quilombo.png',
  stage_07_olinda: 'bg_olinda.png',
  stage_07b_lacerda: 'bg_elevador_lacerda.png',

  // Capítulo 2
  stage_08_barracao: 'bg_barracao.png',
  stage_09_engenho: 'bg_engenho.png',
  stage_10_terreiro: 'bg_terreiro.png',
  stage_11_porto_barra: 'bg_praia_porto_barra.png',
  stage_12_cachoeira: 'bg_cachoeira_mata.png',
  stage_13_sertao: 'bg_sertao.png',
  stage_14_cais: 'bg_cais_porto.png',
  stage_15_carnaval: 'bg_carnaval_salvador.png',
  
  // Capítulo 3
  stage_16_santos: 'bg_praia_santos.png',
  stage_17_iracema: 'bg_praia_iracema.png',
  stage_18_patio_colegio: 'bg_patio_colegio.png',
  stage_19_copacabana: 'bg_copacabana.png',
  stage_20_masp: 'bg_masp.png',
  stage_21_praca_se: 'bg_praca_se.png',
  stage_22_ouro_preto: 'bg_ouro_preto.png',
  stage_23_jardim_botanico: 'bg_jardim_botanico.png',
  stage_24_manaus: 'bg_manaus_teatro.png',
  stage_25_brasilia: 'bg_brasilia_congresso.png',
  stage_26_pantanal: 'bg_pantanal.png',

  // Novas Expansões
  stage_27_pelourinho_dawn: 'bg_pelourinho_amanhecer.png',
  stage_28_cais_salvador: 'bg_cais_porto_salvador.png',
  stage_29_recife_antigo: 'bg_recife_antigo.png',
  stage_30_lencois: 'bg_lencois_maranhenses.png',
  stage_31_mata_caipora: 'bg_mata_caipora.png',
  stage_32_periferia: 'bg_praca_periferia.png',
  stage_33_missoes: 'bg_missoes.png',
  stage_34_ipanema: 'bg_ipanema.png',
  stage_35_amazonia_boto: 'bg_amazonia_rio.png',
  stage_36_mapinguari: 'bg_floresta_profunda.png',
  stage_37_pisadeira: 'bg_telhados_noite.png',
  stage_38_corpo_seco: 'bg_cemiterio_sertao.png',
  stage_39_mae_do_ouro: 'bg_mina_ouro.png',
  stage_bonus_ipanema: 'bg_fazenda_ipanema.png',
  stage_bonus_ipanema_ponte: 'bg_fazenda_ipanema_ponte.png',
  stage_bonus_ipanema_fachada: 'bg_fazenda_ipanema_fachada.png',
  stage_bonus_ipanema_exterior: 'bg_fazenda_ipanema_exterior.png',
  stage_bonus_ipanema_porta: 'bg_fazenda_ipanema_porta.png',

  // Especiais — reaproveitam assets existentes com tratamento visual distinto
  boss_mestre_passaro: 'bg_quilombo.png',
  boss_curupira_mata: 'bg_pantanal.png',
  special_berimbau_touch: 'bg_berimbau_treino.png',
  rhythm_berimbau_basico: 'bg_terreiro.png',
  training_sala: 'bg_barracao.png',
  special_boss_rush: 'bg_templo.png',
}

export function getStageBackground(stageId: string): string {
  return ASSET_BASE + (STAGE_BACKGROUND[stageId] ?? FALLBACK_FILE)
}
